import { render } from "./features_section.html?vue&type=template&id=52bc058f&external"
import script from "./features_section.js?vue&type=script&lang=js&external"
export * from "./features_section.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__